import React from 'react';

const Footer = () => {
  return (
    <footer className="bg-dark text-white pt-5 pb-4">
      <div className="container text-md-left">
        <div className="row text-md-left">

          {/* Branding */}
          <div className="col-md-3 col-lg-3 col-xl-3 mx-auto mt-3">
            <h5 className="text-uppercase mb-4 font-weight-bold text-warning">Abdur Rouf</h5>
            <p>Feel free to reach out if you want to collaborate with us.</p>
            <h6 className="text-uppercase mt-4">Follow Us</h6>
            {/* Add social media icons here if needed */}
          </div>

          {/* Service Links */}
          <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
            <h6 className="text-uppercase mb-4 font-weight-bold">Service</h6>
            <p><a href="/" className="text-white text-decoration-none">Store Directory</a></p>
            <p><a href="/" className="text-white text-decoration-none">Top Hotels</a></p>
            <p><a href="/" className="text-white text-decoration-none">Knowledge Center</a></p>
          </div>

          {/* Company Links */}
          <div className="col-md-2 col-lg-2 col-xl-2 mx-auto mt-3">
            <p><a href="/" className="text-white text-decoration-none">Home</a></p>
            <p><a href="/" className="text-white text-decoration-none">About Us</a></p>
            <p><a href="/" className="text-white text-decoration-none">Services</a></p>          
            <p><a href="/" className="text-white text-decoration-none">Contact</a></p>
          </div>

          {/* Contact Info */}
          <div className="col-md-5 col-lg-4 col-xl-4 mx-auto mt-3">
            <h6 className="text-uppercase mb-4 font-weight-bold">Dhaka</h6>
            <p>rouf2025s@gmail.com</p>
            <h6 className="text-uppercase mt-4 mb-2 font-weight-bold">Chattogram</h6>
            <p>raufabdurr009@gmail.com</p>
          </div>
        </div>

        <hr className="mb-4" />

        {/* Footer Bottom */}
        <div className="row align-items-center">
          <div className="col-md-12 text-center">
            <p className="mb-0">© developed by Abdur Rouf. ThemeMascot Agency.</p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
